import { Form, FormItemProps, Select, SelectProps } from 'antd';

interface Props {
  from: number;
  to: number;
  formProps: FormItemProps;
  selectProps?: SelectProps;
}

export const HoursSelector = ({ from, to, formProps,selectProps }: Props) => (
  <Form.Item
    {...formProps}
  >
    <Select
      {...selectProps}
    >
      {
        Array.from({ length: to - from + 1 }, (_, i) => (
          <Select.Option key={from + i} value={from + i}>
            {`${from + i}:00`}
          </Select.Option>
        ))
      }
    </Select>
  </Form.Item>
);
